import { types } from "../../types/types";

const initialState = {
  coins: []
}

export const coinReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.coinsStartLoading:
      return{
        ...state,
        coins: [ ...action.payload ]
      }

    default:
      return state;
  }
}